import LoginComponent from "@/components/LoginComponent.vue";
import RegisterComponent from "@/components/RegisterComponent.vue";
import ProfileComponent from "@/components/ProfileComponent.vue";
import PaymentComponent from "@/components/PaymentComponent.vue";
import ServicesComponent from "@/components/ServicesComponent.vue";
import HistoryComponent from "@/components/HistoryComponent.vue";
import FeedbackComponent from "@/components/FeedbackComponent.vue";
// import DocumentsComponent from "@/components/DocumentsComponent.vue";
import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "profile",
    component: ProfileComponent,
    meta: { loggedIn: true },
  },
  {
    path: "/pay/:client",
    name: "payment",
    component: PaymentComponent,
    meta: { loggedIn: true },
  },
  {
    path: "/services/:page(\\d+)?",
    name: "services",
    component: ServicesComponent,
    meta: { loggedIn: true },
  },
  {
    path: "/login",
    name: "login",
    component: LoginComponent,
    meta: { loggedIn: false },
  },
  {
    path: "/register",
    name: "register",
    component: RegisterComponent,
    meta: { loggedIn: false },
  },
  {
    path: "/history",
    name: "history",
    component: HistoryComponent,
    meta: { loggedIn: true },
  },
  {
    path: "/feedback",
    name: "feedback",
    component: FeedbackComponent,
    meta: { loggedIn: true },
  },
  // {
  //   path: "/documents",
  //   name: "documents",
  //   component: DocumentsComponent,
  //   meta: { loggedIn: true },
  // }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
